import * as React from 'react';
import { InputNumber, Button } from 'antd';
import { useTranslation } from 'react-i18next';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
    },
    quickButtons: {
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap' as const,
    },
    quickButton: {
        borderRadius: '16px',
        fontSize: '12px',
        padding: '2px 12px',
        height: 'auto',
    },
    quickButtonActive: {
        backgroundColor: '#1890ff',
        borderColor: '#1890ff',
        color: '#fff',
    },
};

const QUICK_OPTIONS = [
    { label: '15 min', value: 900 },
    { label: '30 min', value: 1800 },
    { label: '45 min', value: 2700 },
    { label: '60 min', value: 3600 },
];

interface GraceTimeInputProps {
    value?: number;
    onChange?: (value: number | null) => void;
    disabled?: boolean;
    placeholder?: string;
}

const GraceTimeInput: React.FC<GraceTimeInputProps> = ({
    value,
    onChange,
    disabled = false,
    placeholder,
}) => {
    const { t } = useTranslation();

    const handleQuickSelect = (seconds: number) => {
        if (onChange) {
            onChange(seconds);
        }
    };

    const handleInputChange = (val: number | null) => {
        if (onChange) {
            onChange(val);
        }
    };

    const isInvalidValue = value !== undefined && value !== null && value !== '' && value <= 0;

    return (
        <div style={styles.container}>
            <InputNumber
                value={value}
                onChange={handleInputChange}
                disabled={disabled}
                placeholder={placeholder || t('enterSecondsGreaterThanZero')}
                style={{ width: '100%' }}
                status={isInvalidValue ? 'error' : undefined}
            />
            {isInvalidValue && (
                <span style={{ color: '#ff4d4f', fontSize: 12 }}>
                    {t('graceTimeMustBePositive')}
                </span>
            )}
            <div style={styles.quickButtons}>
                {QUICK_OPTIONS.map((option) => (
                    <Button
                        key={option.value}
                        size="small"
                        disabled={disabled}
                        type={value === option.value ? 'primary' : 'default'}
                        style={{
                            ...styles.quickButton,
                            ...(value === option.value ? styles.quickButtonActive : {}),
                        }}
                        onClick={() => handleQuickSelect(option.value)}
                    >
                        {option.label}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default GraceTimeInput;
